'use client'

import { Typography } from '../Contentful'

function QuickTipContent({ content, name }) {
  return (
    <div className="flex flex-col gap-4 bg-gray-100 p-6 pb-8 my-4 border border-solid border-gray-200">
      <Typography content={name} className="headingMd font-light!" component="h6" />
      <Typography content={content} className="bodyLg" />
    </div>
  )
}

export { QuickTipContent }
